import type { SkeletonProps } from './Skeleton.types';
import './Skeleton.scss';

export default function Skeleton({
  shape = 'rect', width, height, className, style,
}: SkeletonProps) {
  const styles = {
    ...(width !== undefined ? { width: typeof width === 'number' ? `${width}px` : width } : {}),
    ...(height !== undefined ? { height: typeof height === 'number' ? `${height}px` : height } : {}),
    ...style,
  };
  return (
    <span
      aria-hidden="true"
      className={['skeleton', `skeleton--${shape}`, className || ''].filter(Boolean).join(' ')}
      style={styles}
    >
      <span className="skeleton__layer" />
    </span>
  );
}
